import { __awaiter, __generator } from "tslib";
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { createGroup, updateGroup, getPlatforms, getStatus, viewGroup } from '@/api/admin/platforms';
import { notify } from '@/utils/toast';
import { toast } from 'vue3-toastify';
import router from '@/routes';
export default defineComponent({
    setup: function () {
        var _this = this;
        var group = ref({
            platformId: null,
            groupName: '',
            accountEmail: '',
            accountPassword: '',
            currentCost: null,
            availableProfiles: null,
            status: 'inactiva',
            bannedAt: null,
        });
        var route = useRoute();
        var platforms = ref([]);
        var statusList = ref([]);
        onMounted(function () {
            getPlatformsList();
            getStatusList();
            //console.log('mounted', route.params.id);
            if (route.params.id !== undefined) {
                getGroupData();
            }
        });
        var create = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, createGroup(group.value)];
                    case 1:
                        _a.sent();
                        router.push('/admin/groups');
                        notify('Grupo o cuenta creada con éxito', 'success', toast.POSITION.BOTTOM_CENTER);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        if (error_1.response.status === 401) {
                            notify('No tiene permisos para esta solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else if (error_1.response.status === 404) {
                            notify('No existe la solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else {
                            console.error(error_1.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var update = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, updateGroup(route.params.id, group.value)];
                    case 1:
                        _a.sent();
                        router.push('/admin/groups');
                        notify('Grupo o cuenta actualizada con éxito', 'success', toast.POSITION.BOTTOM_CENTER);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        if (error_2.response.status === 401) {
                            notify('No tiene permisos para esta solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else if (error_2.response.status === 404) {
                            notify('No existe la solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else {
                            console.error(error_2.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var submitForm = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(route.params.id === undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, create()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, update()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var getGroupData = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, data, status, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, viewGroup(route.params.id)];
                    case 1:
                        _a = _b.sent(), data = _a.data, status = _a.status;
                        if (status === 200) {
                            group.value = data;
                        }
                        else {
                            notify('No se pudo cargar la lista de plataformas', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _b.sent();
                        if (error_3.response.status === 401) {
                            notify('No tiene permisos para esta solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else if (error_3.response.status === 404) {
                            notify('No existe la solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else {
                            console.error(error_3.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var getPlatformsList = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, data, status, error_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getPlatforms({ per_page: 1000 })];
                    case 1:
                        _a = _b.sent(), data = _a.data, status = _a.status;
                        if (status === 200) {
                            platforms.value = data.data;
                        }
                        else {
                            notify('No se pudo cargar la lista de plataformas', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _b.sent();
                        if (error_4.response.status === 401) {
                            notify('No tiene permisos para esta solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else if (error_4.response.status === 404) {
                            notify('No existe la solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else {
                            console.error(error_4.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var getStatusList = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, data, status, error_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getStatus()];
                    case 1:
                        _a = _b.sent(), data = _a.data, status = _a.status;
                        if (status === 200) {
                            statusList.value = data;
                        }
                        else {
                            notify('No se pudo cargar la lista de plataformas', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _b.sent();
                        if (error_5.response.status === 401) {
                            notify('No tiene permisos para esta solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else if (error_5.response.status === 404) {
                            notify('No existe la solicitud', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        else {
                            console.error(error_5.message);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return {
            group: group,
            platforms: platforms,
            statusList: statusList,
            submitForm: submitForm,
        };
    }
});
